module.exports = __webpack_public_path__ + "01babfade65cc4f567e0a5b3b150ae3f.svg";